import { render, staticRenderFns } from "./DeleteAnswer.vue?vue&type=template&id=027be583&"
import script from "./DeleteAnswer.vue?vue&type=script&lang=js&"
export * from "./DeleteAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports